import React, { Component } from "react";
import '../../Styles/AddRisks.scss'
import Images from "../../Assets/Images";

export default class AddRisks extends Component {  
  render() {
    return (
      <div className="riskContainer">
        <div className="dbCard card100 addProjectCard">
          <div className="gridBox">
            <div className="gridHeader">
              <h4>Add Risks</h4>
            </div>
            <form name="form">
              <div className="formCont">
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Risk</label>
                    <input
                      type="text"
                      name="risk"
                      className="form-control"
                      placeholder="Enter Project Name"
                    />
                  </div>
                </div>

                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Risk Type</label>
                    <select name="risktype" className="form-control">
                      <option></option>
                    </select>
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Project Stage</label>
                    <select name="risktype" className="form-control">
                      <option></option>
                    </select>
                  </div>
                </div>

                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Cause </label>
                    <input type="text" autoComplete="off" name="cause" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Existing Control </label>
                    <input type="text" autoComplete="off" name="control" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Frequency </label>
                    <input type="text" name="frequency" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Project Loss($ boe/day) </label>
                    <input type="text" name="loss" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Project Cost Increase($) </label>
                    <input type="text" name="cost" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Project Duration Increase(days) </label>
                    <input type="text" name="duration" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Share Price Reduction (%) </label>
                    <input type="text" name="reduction" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Impact Comments </label>
                    <input type="text" name="comments" className="form-control" />
                  </div>
                </div>
                <div className="formCol">
                  <div className="fieldContainer">
                    <label>Proximity Date</label>
                    <input type="date" name="date" className="form-control" />
                  </div>
                </div>



              </div>

              <div className="formBtn">
                <button className="rm-btn-primary">
                  Submit
                </button>
                &nbsp;&nbsp;
                <button className="rm-btn-primary">
                  Cancel
                </button>
              </div>


            </form>
          </div>
        </div>
      </div>
    );
  }
}

